import { useOfferCart, useSelectedStep } from '@fhs/loyalty/src/state/offer-guide-cart-state';
import { ICartEntry } from '@rbi-ctg/menu';
import { useIsEditCartEnabled } from 'hooks/use-is-edit-cart-enabled';
import { useOrderContext } from 'state/order';

import { useProductWizardContext } from '../index';

import useProductWizardFlow from './use-product-wizard-flow';

export const useEditingCartEntry = (isSimplyOffer?: boolean): ICartEntry | undefined => {
  const selectedStep = useSelectedStep();
  const { isEdit: isSimplyOfferEdit } = useOfferCart();

  const { isEdit } = useProductWizardFlow();
  const { isSimplyOffer: isSimplyOfferFromContext } = useProductWizardContext();
  const finalIsSimplyOffer = isSimplyOffer ?? isSimplyOfferFromContext;
  const enableEditCart = useIsEditCartEnabled({ cartHasIncentive: finalIsSimplyOffer });
  const { getCurrentCartEntry, cartIdEditing } = useOrderContext();
  const isEditing =
    (finalIsSimplyOffer && isSimplyOfferEdit) || (enableEditCart && isEdit && cartIdEditing);
  const editingCartEntry = finalIsSimplyOffer
    ? selectedStep?.selectedEntry
    : getCurrentCartEntry(finalIsSimplyOffer);

  return isEditing ? editingCartEntry : undefined;
};
